import React, { useState, useEffect } from 'react';
import { LOGO_URL as logo } from '../../../services';
import esra from '../../../assets/esra.webp';
import ipek from '../../../assets/ipek.webp';
import melisa from '../../../assets/melisa.webp';
import serkan from '../../../assets/serkan.webp';
import { klavyeIleTikla } from "../../../utils/a11y"; // FE-78: tıklanabilir öğelerde klavye desteği

const reviews = [
    {
        avatar: serkan,
        name: 'Serkan A.',
        rating: 5,
        text: 'Nakliye ve depo işlerini o kadar zor sanırdım ve gözümde o kadar büyütürdüm ki bu sürecin bu kadar sorunsuz ilerleyeceğini hiç tahmin etmezdim. Ta ki Troy Depo ile tanışana kadar. Tüm tanıdıklarıma gönül rahatlığıyla sizi önereceğim. Umarım bu tarz işlerimde hep birlikte çalışma fırsatı yakalarız.'
    },
    {
        avatar: esra,
        name: 'Esra A.',
        rating: 5,
        text: 'Başından sonuna kadar çok ilgiliydiniz. Gelen çocuklar pırlanta gibiydi. Güzel deneyim için sizlere teşekkür ederim.'
    },
    {
        avatar: melisa,
        name: 'Melisa K.',
        rating: 5,
        text: 'Çok memnun kaldım. Eksik bilgi verdiğim ve bazı öngöremediğim durumlar nedeniyle operasyonda aksaklıklar yaşanmasına rağmen, ekip süreci çok iyi yönetti.  Bu sayede kaliteli bir deneyim yaşamış oldum. Tüm ekibe teşekkür ediyorum.'
    },
    {
        avatar: ipek,
        name: 'İpek D.',
        rating: 5,
        text: 'Operasyon gerçekten çok başarılıydı tüm detaylara dikkat etti ekip ve hep doğru yönlendirdiler. Çok keyifli bir operasyon oldu.'
    }

];

const InfoSection = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Sayaç currentIndex'e BAĞLI: noktalara tıklanınca 3 saniyelik periyot baştan başlar.
    // Eskiden interval bir kez kuruluyordu ve tıklama periyodun sonuna denk gelirse seçilen
    // yorum neredeyse anında değişiyordu.
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex(prev => (prev + 1) % reviews.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [currentIndex]);

    return (
        <div className="info-section">
            {/* Logo yorum kartının en üstünde ortalı durur. */}
            <img src={logo} alt="Troy Depo" className="auth-info-logo" />
            <span className="info-section-title">Depolamanın Güvenilir Adresi!</span>

            {/* Yorumlar çok farklı uzunlukta (en kısa ~110, en uzun ~350 karakter). Yalnız aktif
                olan basılırsa kart her 3 saniyede bir boy değiştiriyor ve beyaz alan zıplıyordu.
                Bu yüzden HEPSİ basılır ve aynı grid hücresine yerleştirilir: konteyner EN UZUN
                yoruma göre boyutlanır, yükseklik sabit kalır. Gizlenenler için display:none
                KULLANILMAZ (layout'tan çıkar, yükseklik yine zıplardı) — visibility kullanılır. */}
            <div className="review-stack">
                {reviews.map((review, idx) => (
                    <div
                        key={review.name}
                        className={`review ${idx === currentIndex ? 'active' : ''}`}
                        aria-hidden={idx !== currentIndex}
                    >
                        <img src={review.avatar} alt={review.name} className="user-image" />
                        <p style={{ color: 'rgba(254, 200, 75, 1)', fontSize: '20px', marginTop: 0 }}>
                            {'★'.repeat(review.rating)}
                        </p>
                        <h3 style={{ marginTop: 0 }}>{review.name}</h3>

                        <p className="info-section-text">
                            {review.text}
                        </p>
                    </div>
                ))}
            </div>

            <div className="review-dots">
                {reviews.map((_, idx) => (
                    <span role="button" tabIndex={0} onKeyDown={klavyeIleTikla}
                        key={idx}
                        className={`dot ${idx === currentIndex ? 'active' : ''}`}
                        onClick={() => setCurrentIndex(idx)}
                    />
                ))}
            </div>
        </div>
    );
};

export default InfoSection;
